import { useState } from "react";
import { Collapse } from "react-bootstrap";
import { Link } from "@tanstack/react-router";
import NiceModal from "@ebay/nice-modal-react";
import { useTranslation } from "react-i18next";
import { ChangeOrgModal } from "../../modules/admin/ChangeOrgModal";
import useDashboardTheme from "../../hooks/useDashboardTheme";
import { FaTags, FaUpload, FaUser, FaUsersGear } from "react-icons/fa6";
import { useAppSelector } from "../../redux/hooks";
import { CgData } from "react-icons/cg";
import { useSimpleCan } from "../../config/casl/casl";
import { useModuleEnabled } from "../../redux/selectors/modules";
import { css } from "../../../styled-system/css";

const ProductOptions = () => {
  const { t } = useTranslation(["common"]);
  const user = useAppSelector((state) => state.user);
  const channel = useAppSelector((state) => state.channel.currentChannel);
  const [openAvatar, setOpenAvatar] = useState(false);
  const { sidebarColor } = useDashboardTheme();

  const userCanUpdateBilling = useSimpleCan("update", "Billing");
  const userCanUpdateOrgSettings = useSimpleCan("update", "Org");
  const userCanUpdateUsers = useSimpleCan("update", "User");
  const hasBulkUploadModule = useModuleEnabled("BULK_CAMPAIGN_UPLOAD");
  const hasTagsEnhancedModule = useModuleEnabled("TAGS_ENHANCED");

  const isActive = (routeName) => {
    return document.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };

  return (
    <div className="user pt-5 border-bottom">
      <div className="photo">
        <FaUser style={{ fontSize: "24px", color: "#2e0054", width: "100%" }} />
      </div>
      <div className="info">
        <a
          href="#pablo"
          onClick={(e) => {
            e.preventDefault();
            setOpenAvatar(!openAvatar);
          }}
        >
          <span>
            <span
              className="sidebar-link"
              style={{
                color: "#2e0054",
              }}
            >
              {user.user_full_name}
            </span>
            <b
              style={{
                color: "#2e0054",
              }}
              className={openAvatar ? "caret rotate-180 dropdown-toggle" : "caret nav  dropdown-toggle"}
            />
          </span>
        </a>
        <Collapse in={openAvatar}>
          <ul className="nav">
            {userCanUpdateUsers && (
              <li className="w-100">
                <Link
                  to="/user/usermanagement"
                  activeProps={{}}
                  style={{
                    borderBottom: isActive("/user/usermanagement") ? `1px solid ${sidebarColor}` : "",
                    borderRadius: 0,
                    color: "#2e0054",
                  }}
                >
                  <span className="sidebar-mini">
                    <FaUsersGear className={css({ fontSize: "xlarge", color: "#2e0054", width: "100%" })} />
                  </span>
                  <span className="sidebar-normal sidebar-link text-dark-purple">
                    {t(($) => $.common.sidebar.Users)}
                  </span>
                </Link>
              </li>
            )}
            {hasTagsEnhancedModule && (
              <li className="w-100">
                <Link
                  to="/user/tagmanagement"
                  activeProps={{}}
                  style={{
                    borderBottom: isActive("/user/tagmanagement") ? `1px solid ${sidebarColor}` : "",
                    borderRadius: 0,
                    color: "#2e0054",
                  }}
                >
                  <span className="sidebar-mini">
                    <FaTags className={css({ fontSize: "xlarge", color: "#2e0054", width: "100%" })} />
                  </span>
                  <span className="sidebar-normal sidebar-link text-dark-purple">
                    {t(($) => $.common.sidebar.Tags)}
                  </span>
                </Link>
              </li>
            )}
            {userCanUpdateOrgSettings && (
              <li style={{ width: "100%" }}>
                {channel === "walmart" ?
                  <Link
                    to="/user/walmartsummary"
                    activeProps={{}}
                    style={{
                      borderBottom: isActive("/user/walmartsummary") ? `1px solid ${sidebarColor}` : "",
                      borderRadius: 0,
                    }}
                  >
                    <span className="sidebar-mini">
                      <i
                        className="fa fa-plug"
                        style={{
                          color: "#2e0054",
                        }}
                      />
                    </span>
                    <span
                      className="sidebar-normal sidebar-link"
                      style={{
                        color: "#2e0054",
                      }}
                    >
                      {t(($) => $.common.sidebar["Walmart Connect"])}
                    </span>
                  </Link>
                : channel === "shopify" ?
                  <Link
                    to="/user/shopifysummary"
                    activeProps={{}}
                    style={{
                      borderBottom: isActive("/user/shopifysummary") ? `1px solid ${sidebarColor}` : "",
                      borderRadius: 0,
                    }}
                  >
                    <span className="sidebar-mini">
                      <i
                        className="fa fa-plug"
                        style={{
                          color: "#2e0054",
                        }}
                      />
                    </span>
                    <span
                      className="sidebar-normal sidebar-link"
                      style={{
                        color: "#2e0054",
                      }}
                    >
                      {t(($) => $.common.sidebar["Shopify Connect"])}
                    </span>
                  </Link>
                : <Link
                    to="/user/amzsummary"
                    activeProps={{}}
                    style={{
                      borderBottom: isActive("/user/amzsummary") ? `1px solid ${sidebarColor}` : "",
                      borderRadius: 0,
                    }}
                  >
                    <span className="sidebar-mini">
                      <i
                        className="fa fa-plug"
                        style={{
                          color: "#2e0054",
                        }}
                      />
                    </span>
                    <span
                      className="sidebar-normal sidebar-link"
                      style={{
                        color: "#2e0054",
                      }}
                    >
                      {t(($) => $.common.sidebar["Amazon Connect"])}
                    </span>
                  </Link>
                }
              </li>
            )}
            {userCanUpdateBilling && (
              <li className="w-100">
                <Link
                  to="/user/billing"
                  activeProps={{}}
                  style={{
                    borderBottom: isActive("/user/billing") ? `1px solid ${sidebarColor}` : "",
                    borderRadius: 0,
                  }}
                >
                  <span className="sidebar-mini">
                    <i
                      className="fa fa-credit-card"
                      style={{
                        color: "#2e0054",
                      }}
                    />
                  </span>
                  <span className="sidebar-normal sidebar-link text-dark-purple">
                    {t(($) => $.common.sidebar.Billing)}
                  </span>
                </Link>
              </li>
            )}
            <li className="w-100">
              <Link
                to="/user/settings"
                activeProps={{}}
                style={{
                  borderBottom: isActive("/user/settings") ? `1px solid ${sidebarColor}` : "",
                  borderRadius: 0,
                }}
              >
                <span className="sidebar-mini">
                  <i
                    className="fa fa-cog"
                    style={{
                      color: "#2e0054",
                    }}
                  />
                </span>
                <span className="sidebar-normal sidebar-link text-dark-purple">
                  {t(($) => $.common.sidebar.Settings)}
                </span>
              </Link>
            </li>
            {hasBulkUploadModule && (
              <li className="w-100">
                <Link
                  to="/user/uploads"
                  activeProps={{}}
                  style={{
                    borderBottom: isActive("/user/uploads") ? `1px solid ${sidebarColor}` : "",
                    borderRadius: 0,
                  }}
                >
                  <span className="sidebar-mini">
                    <FaUpload className={css({ fontSize: "xlarge", color: "#2e0054", width: "100%" })} />
                  </span>
                  <span className="sidebar-normal sidebar-link text-dark-purple">
                    {t(($) => $.common.sidebar.Uploads)}
                  </span>
                </Link>
              </li>
            )}
            <li className="w-100">
              <Link
                to="/user/trmnl"
                activeProps={{}}
                style={{
                  borderBottom: isActive("/user/trmnl") ? `1px solid ${sidebarColor}` : "",
                  borderRadius: 0,
                }}
              >
                <span className="sidebar-mini">
                  <CgData style={{ fontSize: "24px", color: "#2e0054", width: "100%" }} />
                </span>
                <span className="sidebar-normal sidebar-link text-dark-purple">
                  {t(($) => $.common.sidebar["Connect TRMNL"])}
                </span>
              </Link>
            </li>
            {user.is_staff && (
              <li className="w-100">
                <Link
                  to="/user/mcp"
                  activeProps={{}}
                  style={{
                    borderBottom: isActive("/user/mcp") ? `1px solid ${sidebarColor}` : "",
                    borderRadius: 0,
                  }}
                >
                  <span className="sidebar-mini">
                    <i
                      className="fa fa-server"
                      style={{
                        color: "#2e0054",
                      }}
                    />
                  </span>
                  <span className="sidebar-normal sidebar-link text-dark-purple">
                    {t(($) => $.common.sidebar["MCP Server"])}
                  </span>
                </Link>
              </li>
            )}
            {/* TODO: Deprecate this option
              (it is now located under Staff Tools, but we will keep it here for now in order to not piss off the CS team) */}
            {user.is_staff && (
              <li className="w-100">
                <a
                  role="button"
                  tabIndex={0}
                  onClick={() => NiceModal.show(ChangeOrgModal)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      NiceModal.show(ChangeOrgModal);
                    }
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <span className="sidebar-mini">
                    <i
                      className="fa fa-group"
                      style={{
                        color: "#2e0054",
                      }}
                    />
                  </span>
                  <span className="sidebar-normal sidebar-link">{t(($) => $.common.sidebar["Switch Profiles"])}</span>
                </a>
              </li>
            )}
          </ul>
        </Collapse>
      </div>
    </div>
  );
};

export default ProductOptions;
